import React from 'react';
import { FastField } from 'formik';

const shouldUpdate = (prev, current) => {
  const { formik, shouldUpdate, ...significant } = prev;
  const currentFormik = current.formik;
  const { name } = current;
  const isChanged =
    formik.values[name] !== currentFormik.values[name] ||
    formik.errors[name] !== currentFormik.errors[name] ||
    formik.touched[name] !== currentFormik.touched[name] ||
    Object.keys(significant).some(key => {
      return prev[key] !== current[key];
    });

  return isChanged;
};

const Fast = props => <FastField {...props} shouldUpdate={shouldUpdate} />;

export default Fast;
